import { Warning } from "@phosphor-icons/react"

import {
  BreakdownHeader,
  type BreakdownLayout,
  ForecastBreakdownSections,
} from "~/components/reusable/ForecastBreakdownHoverCard"
import { InteractiveCell, InteractiveCellCardBody } from "~/components/reusable/InteractiveCell"
import { type IVariantSummary } from "~/hooks/useVariantTableData"
import { getAlerts } from "~/utils/forecast-alert-utils"

const cardLayout: BreakdownLayout = ({ title, identity, body }) => (
  <>
    <BreakdownHeader title={title} identity={identity} />
    <InteractiveCellCardBody>{body}</InteractiveCellCardBody>
  </>
)

type Props = {
  variant: IVariantSummary
  forecastAlertThreshold: number
}

/** The Demand alert cell: the alert (or "No alert"), with the demand breakdown in its card. */
export function DemandAlertCell({ variant, forecastAlertThreshold }: Props) {
  const alerts = getAlerts(variant, forecastAlertThreshold) ?? []
  return (
    <InteractiveCell
      icon={<Warning className="size-3.5 shrink-0 text-fg-warning-icon" weight="fill" />}
      label={alerts.length > 0 ? alerts.join(", ") : undefined}
      emptyLabel="No alert"
      card={
        <ForecastBreakdownSections
          variants={[variant]}
          forecastAlertThreshold={forecastAlertThreshold}
          layout={cardLayout}
          highlightAlerts
        />
      }
    />
  )
}
